import React, { useState } from 'react';

const DocumentPreview = ({ document }) => {
  const [showModal, setShowModal] = useState(false);

  if (!document) return <span className="text-gray-500">-</span>;

  let url = '';
  let name = '';
  let type = '';

  if (typeof document === 'string') {
    url = document;
    name = url.split('/').pop();
    // Cek extension file dari url
    const ext = url.split('.').pop().toLowerCase();
    if (['pdf'].includes(ext)) type = 'pdf';
    else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) type = 'image';
    else type = 'unknown';
  } else if (typeof document === 'object') {
    url = document.url || '';
    name = document.name || url.split('/').pop();
    type = document.type || '';
    if (!type) {
      // kalau belum ada type, cek dari url
      const ext = url.split('.').pop().toLowerCase();
      if (['pdf'].includes(ext)) type = 'pdf';
      else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) type = 'image';
      else type = 'unknown';
    }
  }

  const handleOpenModal = () => {
    if (type === 'image' || type === 'pdf') {
      setShowModal(true);
    } else {
      alert('Format file tidak didukung.');
    }
  };

  return (
    <>
      <button onClick={handleOpenModal} className="text-blue-600 underline">
        {name || 'Lihat File'}
      </button>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50" onClick={() => setShowModal(false)}>
          <div className="bg-white rounded-lg max-w-3xl max-h-[80vh] p-4 overflow-auto" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setShowModal(false)} className="mb-2 text-red-500 font-bold">
              Tutup
            </button>

            {type === 'image' && <img src={url} alt={name} className="max-w-full max-h-[70vh] object-contain" />}

            {type === 'pdf' && <iframe src={url} title={name} className="w-full h-[70vh]" />}

            {type === 'unknown' && <p>Format file tidak didukung.</p>}
          </div>
        </div>
      )}
    </>
  );
};

export default DocumentPreview;
